import { useEffect } from 'react';
import { useAuth } from '../state/auth/useAuth';
import { useNavigate } from 'react-router-dom';
import { getDashboardPath, isAuthRoute } from '../utils/navigation';
import { preventBackNavigation, setupHistoryPrevention } from '../utils/historyManager';

/**
 * Component to prevent back navigation to auth pages from dashboard pages
 * This adds an extra layer of protection against back button navigation
 */
export default function NavigationPreventer() {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated || !user) return;
    
    // Set up comprehensive history prevention
    const cleanup = setupHistoryPrevention();
    
    const handlePopState = (event) => {
      const currentPath = window.location.pathname;
      
      if (isAuthRoute(currentPath)) {
        // Prevent navigation to auth routes
        event.preventDefault();
        
        // Redirect back to appropriate dashboard
        const dashboardPath = getDashboardPath(user.role);
        
        // Force navigation back to dashboard
        window.history.replaceState(null, '', dashboardPath);
        navigate(dashboardPath, { replace: true });
      }
    };
    
    // Additional popstate listener for auth route prevention
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      if (cleanup) cleanup();
    };
  }, [isAuthenticated, user, navigate]);

  return null; // This component doesn't render anything
}